import React, { Component, createContext } from 'react';
import { Toast } from 'primereact/toast';

export const NotificationContext = createContext(null);

class NotificationProvider extends Component {
  constructor(props) {
    super(props);
    this.toast = React.createRef();
    this.showSuccess = this.showSuccess.bind(this);
    this.showError = this.showError.bind(this);
    this.showWarn = this.showWarn.bind(this);
    this.showInfo = this.showInfo.bind(this);
    this.showMessage = this.showMessage.bind(this);
  }

  showSuccess(summary, detail, life = 5000) {
    this.toast.current && this.toast.current.show({
      severity: 'success',
      summary,
      detail,
      life,
    });
  }

  showError(summary, detail, life = 8000) {
    this.toast.current && this.toast.current.show({
      severity: 'error',
      summary,
      detail,
      life,
    });
  }

  showWarn(summary, detail, life = 5000) {
    this.toast.current && this.toast.current.show({
      severity: 'warn',
      summary,
      detail,
      life,
    });
  }

  showInfo(summary, detail, life = 5000) {
    this.toast.current && this.toast.current.show({
      severity: 'info',
      summary,
      detail,
      life,
    });
  }

  showMessage(msg) {
    this.toast.current && this.toast.current.show(msg);
  }

  render() {
    const contextValue = {
      showSuccess: this.showSuccess,
      showError: this.showError,
      showWarn: this.showWarn,
      showInfo: this.showInfo,
      showMessage: this.showMessage,
    };

    return (
      <NotificationContext.Provider value={contextValue}>
        <Toast ref={this.toast} style={{ marginTop: '30px' }} />
        {this.props.children}
      </NotificationContext.Provider>
    );
  }
}

export default NotificationProvider;
